export const getBrowserName = () => {
  const userAgent = navigator.userAgent;

  if (/Opera|OPR\//.test(userAgent)) {
    return "Opera";
  } else if (/Edg\//.test(userAgent)) {
    return "Edge";
  } else if (/Chrome\//.test(userAgent)) {
    return "Chrome";
  } else if (/Safari\//.test(userAgent)) {
    return "Safari";
  } else if (/Firefox\//.test(userAgent)) {
    return "Firefox";
  } else if (/MSIE|Trident/.test(userAgent)) {
    return "IE";
  } else {
    return "unknown";
  }
};
